import { TechnicalCardSearchMethodEnum } from "../../enum/chart/technical-data";
import { RoleEnum } from "./role.interface";

export enum UserTypeEnum {
  LOCATION = "LOCATION",
  FRANCHISE = "FRANCHISE",
  NONE = "NONE"
}
export const roleToUserTypeMap: Record<RoleEnum, UserTypeEnum> = {
  [RoleEnum.ROLE_FRANCHISE]: UserTypeEnum.FRANCHISE,
  [RoleEnum.ROLE_LOCATION]: UserTypeEnum.LOCATION,
  [RoleEnum.ROLE_ADMIN]: UserTypeEnum.NONE,
  [RoleEnum.ROLE_ADVERTISER]: UserTypeEnum.NONE,
};

export const userTypeMapToFilteredRole: Record<UserTypeEnum, TechnicalCardSearchMethodEnum> = {
  [UserTypeEnum.FRANCHISE]: TechnicalCardSearchMethodEnum.FRANCHISE,
  [UserTypeEnum.LOCATION]: TechnicalCardSearchMethodEnum.LOCATION,
  [UserTypeEnum.NONE]: TechnicalCardSearchMethodEnum.NONE
};